import api from '../api/administrativeArea'
import { fetchFilteredAdministrativeAreas } from './api'
// Actions
export const actionTypes = {
  RECEIVE_ADMINISTRATIVEAREAS: 'administrative_area/RECEIVE_ADMINISTRATIVEAREAS',
  RECEIVE_ALL_ADMINISTRATIVEAREAS: 'administrative_area/RECEIVE_ALL_ADMINISTRATIVEAREAS',
  START_GET_ADMINISTRATIVEAREAS: 'administrative_area/START_GET_ADMINISTRATIVEAREAS',
  RECEIVE_ADMINISTRATIVEAREAS_DETAIL: 'administrative_area/RECEIVE_ADMINISTRATIVEAREAS_DETAIL',
  RECEIVE_ADMINISTRATIVEAREAS: 'administrative_area/RECEIVE_ADMINISTRATIVEAREAS',
  ALL_RECEIVE_ADMINISTRATIVEAREAS: 'administrative_area/ALL_RECEIVE_ADMINISTRATIVEAREAS',
  RECEIVE_VISIBLE_ADMINISTRATIVEAREAS: 'administrative_area/RECEIVE_VISIBLE_ADMINISTRATIVEAREAS',
  SET_PLACES: 'administrative_area/SET_PLACES',
  RECEIVE_TOTAL_SALE: 'administrative_area/RECEIVE_TOTAL_SALE',
  RECEIVE_TOTAL_RENT: 'administrative_area/RECEIVE_TOTAL_RENT',
  RECEIVE_TOTAL_ADMIN_RENT: 'administrative_area/RECEIVE_TOTAL_ADMIN_RENT',
  RECEIVE_TOTAL_ADMIN_SALE: 'administrative_area/RECEIVE_TOTAL_ADMIN_SALE',
  RESET_PLACES: 'administrative_area/RESET_PLACES',
  ERROR: 'administrative_area/ERROR'
}

// Action creators

export const loadAdministrativeAreas = () => {
  return (dispatch, getStore) => {
    dispatch(startgetAdministrativeAreas())
    let params = dispatch(fetchFilteredAdministrativeAreas())
    api.fetchAdministrativeAreas(params)
      .then((data) => dispatch(receiveAdministrativeAreas(data)))
      .catch((err) => dispatch(error(err)))
  }
}

export const loadAllAdministrativeAereas = () => {
  return (dispatch) => {
    api.fetchAllAdministrativeAreas({})
      .then((data) => dispatch(receiveAllAdministrativeAreas(data)))
  }
}

export const receiveAllAdministrativeAreas = (APIdata)  => {
  return {
    type: actionTypes.RECEIVE_ALL_ADMINISTRATIVEAREAS,
    list: APIdata
  }
}

export const startgetAdministrativeAreas = ()  => {
  return {
    type: actionTypes.START_GET_ADMINISTRATIVEAREAS
  }
}

export const receiveAdministrativeAreas = (APIdata)  => {
  return {
    type: actionTypes.RECEIVE_ADMINISTRATIVEAREAS,
    list: APIdata
  }
}

export const loadVisibles = () => {
  return (dispatch, getStore) => {
    api.fetchVisibleAdministrativeAreas()
      .then((data) => dispatch(receiveVisibleAdministrativeAreas(data)))
  }
}

function receiveVisibleAdministrativeAreas(APIdata) {
  return {
    type: actionTypes.RECEIVE_VISIBLE_ADMINISTRATIVEAREAS,
    list: APIdata
  }
}

function error(APIdataerr) {
  return {
    type: actionTypes.ERROR,
    error: APIdataerr
  }
}

export const loadCaracteristics = (id) => {
  return (dispatch, getStore) => {
    api.totalSaleResults()
      .then((data) => dispatch(receiveTotalSale(data)))
    api.totalRentResults()
      .then((data) => dispatch(receiveTotalRent(data)))
    api.totalAdministrativeAreaRentResults(id)
      .then((data) => dispatch(receiveTotalAdministrativeAreaRent(data)))
    api.totalAdministrativeAreaSaleResults(id)
      .then((data) => dispatch(receiveTotalAdministrativeAreaSale(data)))
  }
}

export const receiveTotalSale = (APIdata) => {
  var total = APIdata.total
  return {
    type: actionTypes.RECEIVE_TOTAL_SALE,
    total
  }
}

export const receiveTotalRent = (APIdata) => {
  var total = APIdata.total
  return {
    type: actionTypes.RECEIVE_TOTAL_RENT,
    total
  }
}

export const receiveTotalAdministrativeAreaRent = (APIdata) => {
  var total = APIdata.total
  return {
    type: actionTypes.RECEIVE_TOTAL_ADMIN_RENT,
    total
  }
}

export const receiveTotalAdministrativeAreaSale = (APIdata) => {
  var total = APIdata.total
  return {
    type: actionTypes.RECEIVE_TOTAL_ADMIN_SALE,
    total
  }
}



// WEBPACK FOOTER //
// ./src/actions/administrativeArea.js